// extracted by mini-css-extract-plugin
module.exports = {"block":"DepartmentBlock_block__2zBHE","departmentName":"DepartmentBlock_departmentName__2EYAz","department":"DepartmentBlock_department__3Ur7J"};